import React from "react";
import { useIntl } from "react-intl";
import { Box, Button, Grid } from "@material-ui/core";
import { getLocalizedValue } from "../../core/lang";
import { MeetingHeader } from "./MeetingHeader";
import CustomIcon from "../../core/custom-icon";
import { Link as RouterLink } from "react-router-dom";
import { MeetingProps } from "./index";
import { ViewAs } from "../../corporation/hooks/meeting";

type Props = {} & MeetingProps;

export const MeetingCancelledPanel = ({
  expert,
  corporation,
  locale,
  date,
  productName,
  productDescription,
  viewAs,
  participant,
}: Props) => {
  const { formatMessage, formatDate } = useIntl();
  return (
    <Box>
      <MeetingHeader
        expert={viewAs === ViewAs.Expert ? participant : expert}
        corporation={corporation}
        locale={locale}
        date={date}
        title={formatMessage({
          id: "MeetingCancelledTitle",
          defaultMessage:
            "Es tut uns leid, das Gespräch konnte nicht stattfinden.",
        })}
        text={formatMessage(
          {
            id: "MeetingCancelledText",
            defaultMessage: `Der Gesrächstermin am {dayName}, den {startDate} 
            mit {expertName} von {corpName}, den Sie im Rahmen der WindEnergy 
            Hamburg vom 1.12. bis 4.12.2020 verinbart haben, konnte leider 
            nicht stattfinden. Verinbaren Sie einen neuen Termin.`,
          },
          {
            dayName: formatDate(date.startDate, {
              weekday: "long",
            }),
            startDate: formatDate(date.startDate),
            corpName: getLocalizedValue(locale, corporation.corpName),
            expertName: expert.fullName,
          }
        )}
      />

      <Grid container spacing={5}>
        <Grid item md={6}></Grid>
        <Grid item md={6}>
          <Box pl={{ xs: 0, md: 7 }} pr={{ xs: 0, md: 7 }}>
            <Box
              display="flex"
              flexDirection={{ xs: "column-reverse", md: "row" }}
              justifyContent="space-between"
              pt={{ xs: 5, md: 7.5 }}
            >
              <Box
                display={{ xs: "block", md: "inline-block" }}
                mt={{ xs: 1.5, md: 0 }}
              >
                <Button
                  variant="text"
                  startIcon={<CustomIcon iconname="calendar" />}
                  fullWidth
                >
                  {formatMessage({
                    id: "MeetingSummaryNewMeetingButton",
                    defaultMessage: "Neuen Termin",
                  })}
                </Button>
              </Box>
              <Button component={RouterLink} to="/">
                {formatMessage({
                  id: "MeetingSummaryDashboardButton",
                  defaultMessage: "Zum Dashboard",
                })}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
